import { z } from "@/zod";
import { time } from "./commonFields/time";
import { dateTime } from "./commonFields/dateTime";
import { NUMBER_SCHEMA } from "./commonFields/numberSchema";

export const timesheetEntryContractorVisit = z.object({
  id: z.string().min(26),
  contractor_id: z.string().min(26),
  contractor_name: z.string(),
  store_id: z.string().min(26),
  store_name: z.string(),
  payroll_department_id: z.string().min(26),
  payroll_department_name: z.string(),
  shift_report_id: z.string().min(26),
  shift_report_date: z.string().date(),
  shift_id: z.string().min(26),
  shift_name: z.string(),
  start_datetime: dateTime,
  end_datetime: dateTime,
  hours_total: z.number().nonnegative().describe(NUMBER_SCHEMA),
  break_time: time,
  break_hours: z.number().nonnegative().describe(NUMBER_SCHEMA),
  hours_without_break: z.number().nonnegative().describe(NUMBER_SCHEMA),
  edit_allowed: z.boolean(),
});

export const readTimesheetEntryContractorVisit =
  timesheetEntryContractorVisit.readonly();
